import React from "react";
import { Box, Typography } from "@mui/material";
import { FONT_SIZE } from "../../../constants/fontSizes";

// 代表者情報のサマリー表示用コンポーネント
const summaryGridSx = {
  display: "grid",
  gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1fr)",
  gap: 2,
  mb: 2.5,
  width: "100%",
};

// ラベルと値のスタイル
const labelSx = {
  mb: 0.5,
  color: "#6B7280",
  fontSize: FONT_SIZE.SM,
};

// 値のスタイル
const valueSx = {
  fontWeight: 600,
  fontSize: FONT_SIZE.MD,
  color: "#1F2937",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
};

function SummaryItem({ label, value }) {
  return (
    <Box sx={{ minWidth: 0 }}>
      <Typography sx={labelSx}>{label}</Typography>
      <Typography sx={valueSx}>{value ?? "-"}</Typography>
    </Box>
  );
}

export default function CompanyUserSummary({
  representativeName,
  representativeEmail,
}) {
  return (
    <Box sx={summaryGridSx}>
      <SummaryItem label="現在の代表者" value={representativeName} />
      <SummaryItem
        label="現代表者のメールアドレス"
        value={representativeEmail}
      />
    </Box>
  );
}
